export const protocolo_item = [
    {
        "nombre": "Conoce las convocatorias para pertenecer a las Personas Consejeras",
        "url": "/ProtocoloCero/Convocatorias",
        "icono": "Convocatoria.jpg"
    },
    {
        "nombre": "Conoce el pronunciamiento de Cero Tolerancia",
        "url": "/pdf/Pronunciamiento.pdf",
        "icono": "Pronunciamiento.jpg"
    },
    {
        "nombre": "Conoce el resultado de exámenes de las personas Consejeras",
        "url": "/ProtocoloCero/Examenes",
        "icono": "examenes.jpg"
    },
    {
        "nombre": "Conoce las cédulas de información de las personas consejeras",
        "url": "/ProtocoloCero/Cedulas",
        "icono": "cedulas.jpg"
    },
    {
        "nombre": "Conoce el Acuerdo que contiene el Protocolo Cero",
        "url": "/pdf/acuerdo_protocolo.pdf",
        "icono": "acuerdo.jpg"
    },

]
export const protocolo2_item = [
    {
        "url": "/pdf/INFORME_2020.pdf",
        "icono": "2020.jpg"
    },
    {
        "url": "/pdf/oficio_Informe_Anual_resultados_2021.pdf",
        "icono": "2021.jpg"

    },
    

]